import { Component, OnInit, Input, ElementRef, Inject, OnDestroy, AfterViewInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AreaItemPack } from './modules/booking/models/area-item-pack';
import { BookingOrderService } from './modules/booking/services/booking-order.service';
import { BookingStepService } from './modules/booking/services/booking-step.service';
import { BookingStepEnum } from './modules/booking/models/booking-step.enum';
import { environment } from '../environments/environment';
import { ShopSettingsService } from './modules/general/services/shop-settings.service';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { VuCommunicationService } from './modules/vu/services/vu-communication.service';
import { DOCUMENT, Location } from '@angular/common';
import { TouchKeyboardService } from './modules/vu/services/touch-keyboard.service';
import { TouchTileService } from './modules/vu/services/touch-tile.service';
import { InactiveTimerService } from './services/inactive-timer.service';
// declare let gtm: Function;
declare let gtag: Function;
declare let fbq: Function;
// declare let ga: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy, AfterViewInit {
  title = 'app';

  spinner_template = '<img src="static/images/spinner/spin-1s-130px.gif"/>';

  @Input() areaItemPack: AreaItemPack;

  onLangChange: Subscription = undefined;

  public get isRootPage(): boolean {
    let url = this.router.url;
    const queryIndex = this.router.url.indexOf('?');
    if (queryIndex >= 0) {
      url = url.substring(0, queryIndex);
    }
    return url === '/';
  }

  public get isPageH75(): boolean {
    return this.router.url.startsWith('/payment/return') ||
      this.router.url.includes('contact-thank-you') ||
      this.router.url.includes('forget_pwd') ||
      this.router.url.includes('subscribe-result') ||
      this.router.url.includes('maintenance') ||
      this.router.url.includes('unsubscribe-result') ||
      this.router.url.includes('screen-saver');
  }

  constructor(
    private router: Router,
    private bookingOrderService: BookingOrderService,
    private bookingStepService: BookingStepService,
    private shopSettingsService: ShopSettingsService,
    private inactiveTimerService: InactiveTimerService,
    private el: ElementRef,
    private translate: TranslateService,
    private vuCommunicationService: VuCommunicationService,
    private touchKeyboardService: TouchKeyboardService,
    private touchTileService: TouchTileService,
    private location: Location,
    @Inject(DOCUMENT) private document: Document,
  ) {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // const spos = (document.documentElement.scrollTop || document.body.scrollTop) + document.documentElement.offsetHeight;
        // const smax = document.documentElement.scrollHeight;
        // const scroll_top = document.documentElement.scrollTop || document.body.scrollTop;
        if ((document.documentElement.scrollTop || document.body.scrollTop) !== 0) {
          window.scrollTo(0, 0);
        }

        const urlAfterRedirects = event.urlAfterRedirects || event.url;
        const pagePath = this.location.prepareExternalUrl(urlAfterRedirects);
        const pageLocation = environment.odooUrl + pagePath;
        const shopLocation = environment.odooDatabaseName;
        if (this.shopSettingsService.googleAnalyticsKey) {
          gtag('event', 'page_view', {
            'send_to': this.shopSettingsService.googleAnalyticsKey,
            'page_location': pageLocation,
            'page_path': pagePath,
          });
        }

        if (this.shopSettingsService.facebookAnalyticsId) {
          this.sendFbq(shopLocation, pageLocation, urlAfterRedirects);
        }

        const activationVuMode = event.url === '/vu' || event.url.startsWith('/vu?') ;
        if (!activationVuMode && this.shopSettingsService.isMaintenanceWebshop) {
          if (event.url !== '/maintenance') {
            this.router.navigate(['maintenance']);
          }
          return;
        }

        if (!activationVuMode && !this.shopSettingsService.isWebshopMode && !this.router.url.startsWith('/kiosk')) {
          this.router.navigate(['/kiosk']);
          return;
        }
      }
    });

    if (this.isVUMode) {
      this.document.body.classList.add('no-select');
      this.document.body.classList.add('no-drag');
    }
  }

  sendFbq(shopLocation: string, pageLocation: string, page: string) {
    fbq('track', 'PageView', {
      'location': shopLocation,
      'page_location': pageLocation,
    });

    const order = this.bookingOrderService.order;
    const viewContentPageUrls = new Map([
      ['/booking/slots', 'Open Flight'],
      ['/booking/event/slots', 'Event Open Flight'],
      ['/giftcard', 'Gift Card'],
      ['/booking/group-event', 'Schulen // Vereine'],
    ]);

    const productViewContentPage = viewContentPageUrls.get(page);
    const areaAreaItemPackName = this.bookingOrderService.areaAreaItemPack && this.bookingOrderService.areaAreaItemPack.name ? this.bookingOrderService.areaAreaItemPack.name : productViewContentPage;
    if (productViewContentPage) {
      fbq('track', 'ViewContent', {
        'location': shopLocation,
        'context_name': pageLocation,
        'content_name': areaAreaItemPackName,
      });
    }

    const viewAddToCartUrls = new Map([
      ['/booking/order', 'Open Flight'],
      ['/giftcard/order', 'Gift Card']]);
    const productAddToCartUrls = viewAddToCartUrls.get(page);
    const orderType = order && order.orderType ? order.orderType : 'unknown';
    if (productAddToCartUrls) {
      fbq('track', 'AddToCart', {
        'location': shopLocation,
        'content_name': areaAreaItemPackName ? areaAreaItemPackName : orderType,
        'value': order.totalAmount,
        'currency': environment.globalSettings.isoCurrencyCode,
      });
    }
  }

  navigateTo(url: string) {
    this.router.navigateByUrl(url);
  }

  ngOnInit() {
    this.updateLanguage();
    this.onLangChange = this.translate.onLangChange.subscribe(() => {
      this.updateLanguage();
    });

    if (this.shopSettingsService.isVUMode) {
      this.vuCommunicationService.initialize();
      this.touchKeyboardService.hide();
      this.touchTileService.rfidCardLedEnable(false);
      this.touchTileService.cardDispenserEnable(false);
    }

    // this.loadingSpinnerService.show();
    // this.loginStateService.initialize().subscribe(
    //   done => {
    //     this.loadingSpinnerService.hide();
    //     this.logger.info('AppComponent: LoginStateService initialized.');
    //   },
    //   error => {
    //     this.loadingSpinnerService.hide();
    //     this.logger.error(`PageMainComponent: appStateService reinitialized error: ${error.message}.`);
    //   }
    // );

    this.document.getElementById('loading-spinner').remove();
  }

  ngOnDestroy(): void {
    if (this.onLangChange) {
      this.onLangChange.unsubscribe();
      this.onLangChange = null;
    }
  }

  ngAfterViewInit(): void {
    document.body.addEventListener('click', this.resetInactiveTimer.bind(this));
  }

  resetInactiveTimer(): void {
    this.inactiveTimerService.resetAndCloseSessionTimerEndWarningDialog();
  }

  updateLanguage(): void {
    const lang = document.createAttribute('lang');
    let langCode = this.translate.currentLang;
    if (langCode.length > 2) {
      langCode = langCode.substring(0, 2);
    }

    lang.value = langCode;
    this.el.nativeElement.parentElement.parentElement.attributes.setNamedItem(lang);
  }

  get areaItemPacks(): AreaItemPack[] {
    return this.bookingOrderService.mainPageAreaItemPacks ? this.bookingOrderService.mainPageAreaItemPacks.filter(x => x.areaItems && x.areaItems.length !== 0) : [];
  }

  areaItemPackClick(areaItemPack: AreaItemPack) {
    if (areaItemPack && areaItemPack.areaItems && areaItemPack.areaItems.length !== 0) {
      this.bookingStepService.update(
        BookingStepEnum.SelectBookingEventsPacks,
        areaItemPack,
        areaItemPack.areaItems[0]
      );
    }
  }

  goToGroupEventPage() {
    this.bookingStepService.update(
      BookingStepEnum.GroupEvent
    );
  }

  get isVUMode(): boolean {
    return this.shopSettingsService.isVUMode;
  }

  public get isKiosk(): boolean {
    return this.router.url.startsWith('/kiosk');
  }

  public get isScreenSaverPage(): boolean {
    const url = this.router.url;
    const queryIndex = url.indexOf('screen-saver');
    if (queryIndex >= 0) {
      return true;
    }
    return false;
  }
}
